import {useState} from 'react';

export function usePage() {
  const [page, setPage] = useState(1);
  const changePage = (_event: React.ChangeEvent<unknown> | null, value: number) => setPage(value);
  return {page, changePage};
}
